module.exports = "/images/EasyPedidoImg.svg";